import * as React from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  IconButton,
  MenuItem,
  Typography,
  Badge,
  Menu,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from "react-i18next";
import { StoreInterfaces } from "../../../types/store/StoreInterfaces";
import { markAsRead, removeNotification } from "../../../store/Notification";

export default function NotificationMenu() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { notifications, unreadCount } = useSelector((state: StoreInterfaces) => state.notification);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleNotificationMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationClick = (notificationId: number, accountId: number, projectId: number, activityId: number,procedureId: number) => {
    dispatch(markAsRead(notificationId));
    navigate(`accounts/${accountId}/projects/${projectId}/activities/${activityId}/procedures/${procedureId}`);
    handleNotificationMenuClose();
  };

  return (
    <>
      <IconButton
        size="small"
        aria-label="show new notifications"
        color="primary"
        onClick={handleNotificationMenuOpen}
      >
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleNotificationMenuClose}
      >
        {notifications.some(n => !n.read) ? (
          notifications.filter(n => !n.read).map((notification) => (
            <MenuItem key={notification.id} sx={{ width: '300px', whiteSpace: 'normal', display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant="body2" onClick={() => handleNotificationClick(notification.id, notification.accountId, notification.projectId, notification.activityId, notification.procedureId)}>
                {t('notifications.new-question')} {notification.procedureName}
              </Typography>
              <IconButton size="small" onClick={(event) => { event.stopPropagation(); dispatch(removeNotification(notification.id)); }}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>
            <Typography variant="body2">{t('notifications.no-new')}</Typography>
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
